export default __webpack_public_path__ + "static/media/TrOut.c96ae99d.svg";